var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from '../utils/api';
/**
 * 全通知を取得する
 * @returns 通知リスト
 */
export const fetchNotifications = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetcher('/api/inside/v1/notifications');
    return response.data;
});
/**
 * 未読通知数を取得する
 * @returns 未読通知数
 */
export const fetchUnreadCount = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetcher('/api/inside/v1/notifications/unread_count');
    return response.data.count;
});
/**
 * 指定された通知を既読にする
 * @param id - 通知ID
 * @returns 更新された通知情報
 */
export const markAsRead = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetcher(`/api/inside/v1/notifications/${id}/mark_as_read`, {
        method: 'POST',
    });
    return response.data;
});
/**
 * 全通知を既読にする
 */
export const markAllAsRead = () => __awaiter(void 0, void 0, void 0, function* () {
    yield fetcher('/api/inside/v1/notifications/mark_all_as_read', {
        method: 'POST',
    });
});
